import { Check, X } from 'lucide-react';

import { VerdictBadge } from '@/components/atoms/VerdictBadge';

import type { ChecklistVerdictCardProps } from './ChecklistVerdictCard.types';

export const ChecklistVerdictCard = ({ verdict }: ChecklistVerdictCardProps) => (
	<article className="flex flex-col gap-xs rounded-md border border-subtle bg-white px-md py-sm">
		<header className="flex items-center justify-between">
			<h3 className="text-[12px] font-semibold text-default">{verdict.judgeName}</h3>
			<VerdictBadge verdict={verdict} />
		</header>
		<ul className="flex flex-col gap-3xs">
			{verdict.results.map((r) => (
				<li key={r.criterionId} className="flex items-start gap-2xs text-[12px] leading-5">
					{r.passed ? (
						<Check className="mt-3xs h-[14px] w-[14px] shrink-0 text-success" />
					) : (
						<X className="mt-3xs h-[14px] w-[14px] shrink-0 text-error" />
					)}
					<div className="min-w-0 flex-1">
						<p className="font-medium text-default">{r.criterionLabel}</p>
						<p className="text-subtle">{r.reasoning}</p>
					</div>
				</li>
			))}
		</ul>
	</article>
);
